import React from 'react';
import './loader.scss';

export function Loader() {
  return (
    <div data-testid="loader" className="loader-container">
      <div className="loader" role="img" />
    </div>
  );
}